import { ChangeEvent } from 'react';
import styles from './InputSimple.module.scss';
import classNames from 'classnames';

interface InputSimpleProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  maxLength?: number;
  isRequired?: boolean;
  disabled?: boolean;
  label?: string;
  nodeRef?: React.RefObject<HTMLInputElement>;
  inputWrapperClassName?: string;
  inputClassName?: string;
}

export const InputSimple = ({
  placeholder,
  value,
  onChange,
  onBlur,
  onKeyDown,
  maxLength = 2000,
  isRequired = false,
  disabled = false,
  label,
  nodeRef,
  inputWrapperClassName,
  inputClassName,
}: InputSimpleProps) => {
  const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
    onChange(target.value);
  };

  const handleBlur = ({ target }: ChangeEvent<HTMLInputElement>) => {
    onBlur?.(target.value);
  };

  return (
    <div className={classNames(styles.root, inputWrapperClassName)}>
      {label && (
        <div className={styles.labelWrapper}>
          <label className={styles.label}>Name</label>
          {isRequired && <label className={styles.required}>Required</label>}
        </div>
      )}
      <input
        ref={nodeRef}
        type="text"
        className={classNames(styles.input, inputClassName)}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
        disabled={disabled}
      />
    </div>
  );
};
